import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Route, RouterLink, RouterLinkActive } from '@angular/router';
import { navChildLink } from './sidenav.routes';

@Component({
    selector: 'sidenav-menu',
    template: `
    
    <div class="side-nav-item-menu" *ngIf="route?.children?.length">
        <div class="fieldset">
            <legend>
                {{route?.data?.title}}
            </legend>

            <ng-container *ngFor="let child of route.children">
                <a class="side-nav-item" [routerLink]="childLink(route, child)" routerLinkActive="active" [attr.data-tour-target]="child.path">

                    <i class="fa" [ngClass]="child.data.icon"></i>
                    <span>{{child?.data?.title}}</span>
                    @if (child.data?.badge) { <span class="nav-new">New</span> }
                </a>
            </ng-container>

        </div>
    </div>
    
    `,
    styles: [
        `
            .side-nav-item.active { 
                color: #4faae7!important;
            }
            /* Marks the v2 screen while its legacy twin is still listed; muted so it reads as a note, not a badge. */
            .side-nav-item .nav-new {
                margin-left: 6px;
                font-size: 11px;
                opacity: 0.55;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, RouterLink, RouterLinkActive]
})
export class SideNavMenuComponent {

    @Input() public route: Route;

    protected readonly childLink = navChildLink;
}
